declare namespace $ {

	type $mol_select__dictionary_shm_tests_scenario_1 = $mol_type_enforce<
		ReturnType< $shm_tests_scenario['versions'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_tests_scenario_2 = $mol_type_enforce<
		ReturnType< $shm_tests_scenario['run_id'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__hint_shm_tests_scenario_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_view__sub_shm_tests_scenario_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_tests_scenario_5 = $mol_type_enforce<
		ReturnType< $shm_tests_scenario['info_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_link__arg_shm_tests_scenario_6 = $mol_type_enforce<
		({ 
			'test_benchmarks': string,
			'test_screenshots': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_tests_scenario_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_tests_scenario_8 = $mol_type_enforce<
		({ 
			'test_screenshots': string,
			'test_benchmarks': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_tests_scenario_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_view__sub_shm_tests_scenario_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_tests_scenario_11 = $mol_type_enforce<
		ReturnType< $shm_tests_scenario['step_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_tests_scenario_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_tests_scenario_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_shm_tests_scenario_14 = $mol_type_enforce<
		ReturnType< $shm_tests_scenario['step_select'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__attr_shm_tests_scenario_15 = $mol_type_enforce<
		({ 
			'hitalama_tests_step_current': ReturnType< $shm_tests_scenario['step_current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__sub_shm_tests_scenario_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_paragraph__title_shm_tests_scenario_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $shm_tests_scenario extends $mol_page {
		page_title( ): string
		Version( ): $mol_select
		Run_tools( ): $mol_view
		info_text( ): string
		Info( ): $mol_text
		Benchmarks( ): $mol_link
		Screenshots( ): $mol_link
		Steps_label( ): $mol_view
		step_rows( ): readonly($mol_view)[]
		Steps( ): $mol_list
		Steps_block( ): $mol_view
		step_select( id: any, next?: any ): any
		step_current( id: any): boolean
		step_title( id: any): string
		Step_title( id: any): $mol_view
		result( ): any
		player( ): any
		display_title( ): string
		versions( ): Record<string, any>
		run_id( next?: string ): string
		benchmarks_open( next?: boolean ): boolean
		screenshots_open( next?: boolean ): boolean
		title( ): ReturnType< $shm_tests_scenario['page_title'] >
		body( ): readonly(any)[]
		Step( id: any): $mol_button_minor
		Empty( ): $mol_paragraph
	}
	
}

//# sourceMappingURL=scenario.view.tree.d.ts.map